import { TranslationKey } from './en';

const ko: Record<TranslationKey, string> = {
  Name: '이름',
  Room: '방 이름',
  Join: '입장',
  BillingNotice: '예약시간 이전에 입장을 하셔도 요금이 부과됩니다. 예약시간에 이용하세요.',
  MuteAudio: '마이크 끄기',
  UnmuteAudio: '마이크 켜기',
  MuteVideo: '카메라 끄기',
  UnmuteVideo: '카메라 켜기',
  ShareScreen: '화면 공유',
  StopSharingScreen: '화면 공유 중지',
  ShareInProgress: '다른 참가자가 화면을 공유하는 중에는 공유할 수 없습니다',
  ShareNotSupported: '이 브라우저에서는 화면 공유를 지원하지 않습니다',
  EndCall: '통화 종료',
};

export default ko;
